module.exports = __webpack_public_path__ + "media/עכבר.a893416f.mp3";